import background from '../img/background.png'
import coming_soon from '../img/coming_soon.jpg'
import mobile_dongle from '../img/RCKT-EMV-Mobile-Dongle-2.png'
import rocket from '../img/Rocket.png'
import valor_handheld from '../img/Valor_VL110_Handheld-POS_angle_2.1.png'
import valor_terminal from '../img/Valor Virtual Terminal.jpg'
import valor_terminal_2 from '../img/Virtual_Terminal.png'
import valor_android from '../img/VL500_Android_POS_3.1.png'

const images = {
    background,
    coming_soon,
    mobile_dongle,
    rocket,
    valor_handheld,
    valor_terminal,
    valor_terminal_2,
    valor_android
}

export default images;